import autosize from "autosize";

up.compiler("textarea", (element) => {
  autosize(element)
})